<template>
  <!-- 购物打卡-打卡明细 -->
  <div>
    <jd-form
      ref="jdForm"
      :form-info="inputData"
      :formData.sync="formList"
      @search="search" />

    <div style="margin: 16px 0 12px" class="flex-between">
      <jd-button
        @click="addCrowd"
        :disabled="tableData.length <= 0"
        >按查询结果生成人群</jd-button
      >
      <jd-button type="text" @click="exportAll">导出</jd-button>
    </div>

    <div class="new-table-box" style="margin-top: 16px">
      <jd-table
        :tableData="tableData"
        :loading="loading"
        :pageInfo="{
          pageSize: formList.size,
          pageNum: formList.current,
          total: total,
          }"
        @handlePage="handlePage"
      >
        <el-table-column prop="memberNick" label="用户昵称" min-width="120">
        </el-table-column>
        <el-table-column
          :prop="searchGrayId"
          :label="`用户${grayText}`"
          min-width="150"
        ></el-table-column>
        <el-table-column prop="sellerLinkName" label="投放渠道" min-width="120">
        </el-table-column>
        <el-table-column prop="cycleName" label="周期名称" width="180">
        </el-table-column>

        <el-table-column prop="buyMoney" label="有效订单金额(元)" width="130" align="right">
        </el-table-column>
        <el-table-column prop="itemNum" label="有效件数(件)" width="120" align="right">
        </el-table-column>
        <el-table-column prop="buyOrder" label="有效笔数(笔)" width="120" align="right">
        </el-table-column>
        <el-table-column
          width="150"
          label="
              是否符合中奖条件
          "
        >
          <template slot-scope="scope">
            <span v-if="scope.row.isPass == 1">符合</span>
            <span v-else>不符合</span>
          </template>
        </el-table-column>
        <el-table-column prop="winTime" label="领奖时间" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.winTime">{{ scope.row.winTime }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="奖品类型" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.prizeType == 1">优惠券</span>
            <span v-if="scope.row.prizeType == 2">京豆</span>
            <span v-if="scope.row.prizeType == 3">实物</span>
            <span v-if="scope.row.prizeType == 4">店铺积分</span>
            <span v-if="scope.row.prizeType == 5">京豆E卡</span>
            <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
            <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
            <span v-if="scope.row.prizeType == 8">现金红包</span>
            <span v-if="scope.row.prizeType == 9">谢谢参与</span>
            <span v-if="scope.row.prizeType == 10">礼品卡</span>
            <span v-else-if="scope.row.prizeType == 13">令牌</span>
            <span v-else-if="scope.row.prizeType == 12">专享价</span>
            <span v-else-if="scope.row.prizeType == 14">实物（随单发）</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="prizeName"
          label="奖品名称"
          width="200"
        ></el-table-column>
      </jd-table>
    </div>
    <!-- <div class="new-pagination-page">
      <el-pagination
        style="text-align: right; margin: 20px"
        @size-change="handleSize"
        background
        @current-change="handleCurrent"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="formList.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="formList.current"
      ></el-pagination>
    </div> -->

    <!-- 生成人群 -->
    <crowdDialog
      v-if="isShowCrowdDialog"
      :isShowCrowdDialog="isShowCrowdDialog"
      :searchForm="formList"
      :activityType="53"
      :source="41"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      @close="crowdClose"
    />

    <!-- 导出 -->
    <generate
      :control="openRemarkDialog"
      v-if="openRemarkDialog"
      @transData="(val) => (openRemarkDialog = val)"
      @transData1="confirmExport"
    ></generate>
  </div>
</template>

<script>
import {
  getShoppingCheckIn,
  exportShoppingCheckIn,
  getCycleInfoList,
} from "@/api/jhk/shoppingCheckIn.js";
import crowdDialog from "../crowd-Dialog.vue";
import statisticsData from "@/mixin/activity_statistics_new.js";
import { customSellerLinkPage } from "@/api/jhk/activityController";
export default {
  mixins: [statisticsData],
  components: {
    crowdDialog,
  },
  props: {
    activityId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      inputData: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "周期名称：",
          prop: "cycleInfoId",
          type: "Select",
          placeholder: "请输入",
          value:'',
          options: [{ label: "全部", value: "" }],
        },
        {
          label: "达标情况：",
          prop: "isPass",
          type: "Select",
          value:'',
          placeholder: "请输入",
          options: [
            { label: "全部", value: "" },
            { label: "只看已达标周期", value: 1 },
            { label: "只看未达标周期", value: 0 },
          ],
        },
         {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
      ],
      tableData: [],
      formList: {
        current: 1,
        size: 10,
        activityId: this.activityId,
      },
      total: 0,
      loading: false,
      isShowCrowdDialog: false, // 生成人群
      hasDefaultValue: false, // 是否有默认值
      defaultValueText: "", // 默认值文本
      openRemarkDialog: false, // 导出备注弹窗
      sellerLinkList:[]
    };
  },
  computed: {
    searchGrayId() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin'
    },
    grayText() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin（加密）'
    },
  },
  watch: {
    searchGrayId: {
      handler(newVal, oldVal) {
        this.inputData.some((item)=>{
          if(item.prop=='pin') {
            item.label = item.label.replace(/pin/ig, newVal)
            item.prop = newVal;
            item.placeholder = item.placeholder.replace(/pin/ig, newVal)
          }
        })
      },
      deep: true,
      immediate: true,
    }
  },
  mounted() {
    this.searchMethods();
    this.getCycleInfoList();
    this.getCustomSellerLinkPage();
  },
  methods: {
    //投放渠道
    getCustomSellerLinkPage() {
      customSellerLinkPage({
        current: 1,
        size: 10000,
        activityId: this.activityId,
      }).then((res)=>{
        if(res.code==1) {
           this.sellerLinkList = res.data.records || [];
           this.sellerLinkList.unshift({
            id: "",
             sellerLinkName: "全部"
           },
           {
             id: "0",
             sellerLinkName: "默认渠道"
            },
          )
          const list = this.sellerLinkList.map((item)=>{
            return {
              label: item.sellerLinkName,
              value: item.id
            }
          })
          this.inputData.some((item)=>{
            if(item.prop=='sellerLinkId') {
              item.options = list
            }
          })
        }
      })
    },
    initSearch(row) {
      this.$refs.jdForm.searchData.memberNick = row.memberNick;
      this.formList.memberNick = row.memberNick;
      this.searchMethods();
    },
    addCrowd() {
      this.hasDefaultValue = true;
      this.defaultValueText = "购物打卡-打卡明细-";
      this.isShowCrowdDialog = true;
    },
    handleOpenDetail(row) {
      this.$emit("handleOpenDetail", row.openid, "checkInDetail");
    },
    exportAll() {
      this.openRemarkDialog = true;
    },

    confirmExport(exportRemark = "") {
      let obj = this.$refs.jdForm.export_fun2();
      let params = {
        ...obj,
        activityId: this.activityId,
        current: 1,
        size: 9999999,
        remark: exportRemark,
      };
      exportShoppingCheckIn(params).then((res) => {});
    },

    handleCurrent(val) {
      this.formList.current = val;
      this.searchMethods();
    },
    handlePage(val) {
       this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.searchMethods();
    },
    handleSize(val) {
      this.formList.size = val;
      this.formList.current = 1;
      this.searchMethods();
    },
    search(params, type) {
      this.formList.current = 1;
      for (const key in params) {
        this.formList[key] = params[key];
      }
      // this.formList = {
      //   ...params,
      //   activityId: this.activityId,
      // };
      this.formList.activityId = this.activityId
      if (type == "reset") {
        this.formList = {
          size: 10,
          current: 1,
          activityId: this.activityId,
        };
      }
      this.searchMethods();
    },
    searchMethods() {
      this.loading = true;
      this.formList[this.searchGrayId] = this.formList[this.searchGrayId] || ""
      getShoppingCheckIn(this.formList)
        .then((res) => {
          if (res.code == 1) {
            let arr = this.processListData(res.data.records);
            this.tableData = arr;
            this.total = Number(res.data.total);
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    processListData(data) {
      return data.flatMap((item) => {
        // 如果存在list数组字段且长度>0
        if (Array.isArray(item.prizeList) && item.prizeList.length) {
          return item.prizeList.map((listItem) => ({
            ...item, // 保留原对象属性
            ...listItem, // 替换为当前list项
          }));
        }
        // 没有list数组时返回原对象
        return [item];
      });
    },
    getCycleInfoList() {
      getCycleInfoList({ activityId: this.activityId }).then((res) => {
        if (res.code == 1) {
          let arr = [];
          res.data.forEach((item) => {
            arr.push({ label: item.cycleName, value: item.id });
          });
          this.inputData[2].options = [{ label: "全部", value: "" }, ...arr];
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    crowdClose() {
      this.isShowCrowdDialog = false;
      // 关闭时重置
      if (this.hasDefaultValue) {
        this.hasDefaultValue = false;
        this.defaultValueText = "";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
